<template>
  <div class="jura-handwerk">

    <b-container>
        <b-row class="text-center">
          <b-col><h1>Unser Handwerk</h1>
            <p>Ein paar Beispiele unserer Arbeit</p>
          </b-col>
        </b-row>
        <b-row class="section mt-5">
            <b-col sm="8">
              <lightbox
                :thumbnail="fassade3NachherThumb"
                :images="fassade3Nachher">
              </lightbox>
              <lightbox
                :thumbnail="fassade4NachherThumb"
                :images="fassade4Nachher">
              </lightbox>
            </b-col>
            <b-col sm="4">
              <strong>Gestaltung Aussenfassade</strong>
            </b-col>
        </b-row>
        <b-row class="section mt-5">
            <b-col sm="8">
              <lightbox
                id="BadGruen"
                :thumbnail="BadGruenThumb"
                :images="BadGruen">
              </lightbox>
            </b-col>
            <b-col sm="4">
              <strong>Objekt: Gäste-WC <br>
              Technik: Spachteltechnik</strong>
            </b-col>
        </b-row>
        <b-row class="section mt-5">
            <b-col sm="8">
              <lightbox
                id="Badezimmer"
                :thumbnail="BadezimmerThumb"
                :images="Badezimmer">
              </lightbox>
            </b-col>
            <b-col sm="4">
              <strong>Objekt: Badezimmer <br>
              Technik: Spachteltechnik</strong>
            </b-col>
        </b-row>
        <b-row class="section mt-5">
            <b-col sm="12">
              <strong>Objekt: Aussenfassade <br>
                Technik: WDVS-System von Brillux</strong>
            </b-col>
            <b-col sm="6">
              <h3>Vorher</h3>
              <lightbox
                :thumbnail="fassadeVorherThumb"
                :images="fassadeVorher">
              </lightbox>
              <lightbox
                :thumbnail="fassadeVorher2Thumb"
                :images="fassadeVorher">
              </lightbox>
            </b-col>
            <b-col sm="6">
              <h3>Nachher</h3>
              <lightbox
                :thumbnail="fassadeNachherThumb"
                :images="fassadeNachher">
              </lightbox>
              <lightbox
                :thumbnail="fassadeNachher2Thumb"
                :images="fassadeNachher">
              </lightbox>
            </b-col>
        </b-row>
        <b-row class="section mt-5">
            <b-col sm="12">
              <strong>Objekt: Aussenfassade <br>
                Technik: Anstrich mit Siliconharzfarbe</strong>
            </b-col>
            <b-col sm="6">
              <h3>Vorher</h3>
              <lightbox
                :thumbnail="fassade2VorherThumb"
                :images="fassade2Vorher">
              </lightbox>
            </b-col>
            <b-col sm="6">
              <h3>Nachher</h3>
              <lightbox
                :thumbnail="fassade2NachherThumb"
                :images="fassade2Nachher">
              </lightbox>
            </b-col>
        </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'start',
  data () {
    return {
      BadGruen: [require('../assets/handwerk/badgruen.jpg')],
      BadGruenThumb: require('../assets/handwerk/badgruen.jpg'),
      Badezimmer: [require('../assets/handwerk/badorange.jpg')],
      BadezimmerThumb: [require('../assets/handwerk/badorange.jpg')],
      fassadeVorher: [require('../assets/handwerk/hausv1.jpg'), require('../assets/handwerk/hausv2.jpg')],
      fassadeNachher: [require('../assets/handwerk/hausn1.jpg'), require('../assets/handwerk/hausn2.jpg')],
      fassade2Vorher: [require('../assets/handwerk/fassadev1.jpg')],
      fassade2Nachher: [require('../assets/handwerk/fassaden1.jpg')],
      fassadeVorherThumb: require('../assets/handwerk/hausv1.jpg'),
      fassadeNachherThumb: require('../assets/handwerk/hausn1.jpg'),
      fassadeVorher2Thumb: require('../assets/handwerk/hausv2.jpg'),
      fassadeNachher2Thumb: require('../assets/handwerk/hausn2.jpg'),
      fassade2VorherThumb: require('../assets/handwerk/fassadev1.jpg'),
      fassade2NachherThumb: require('../assets/handwerk/fassaden1.jpg'),
      fassade3NachherThumb: require('../assets/handwerk/Fassadengestaltung1.jpg'),
      fassade3Nachher: [require('../assets/handwerk/Fassadengestaltung1.jpg')],
      fassade4NachherThumb: require('../assets/handwerk/Fassadengestaltung.jpg'),
      fassade4Nachher: [require('../assets/handwerk/Fassadengestaltung.jpg')],
      options: {
        closeText: 'X',
        nav: false,
        enableKeyboard: false,
        showCounter: false
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.jura-handwerk {
  padding: 40px 0;

  .section {
    background: #f0f0f0;
    padding: 20px;
  }

  .lightbox__thumbnail {
    img {
      border: 2px solid #fff;
      margin-top: 10px;
      display: block;
      width: 100%;
      max-width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Handwerk.vue